import { Component, computed, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection, CmsContentType, CmsTaxonomyGeneral } from '@fcom/core-api';

import { getFontLevel, getHeaderLevel } from '../../services/cms-utils/cms-utils';

@Component({
  selector: 'cms-arrow-link-list',
  templateUrl: './cms-arrow-link-list.component.html',
  styleUrl: './cms-arrow-link-list.component.scss',
  standalone: false,
})
export class CmsArrowLinkListComponent {
  readonly DEFAULT_HEADER_LEVEL = 3;
  readonly CmsTaxonomyGeneral = CmsTaxonomyGeneral;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly CmsContentType = CmsContentType;

  content = input.required<CmsCollection>();
  arrows = input<boolean>(true);

  headerLevel = computed((): number => {
    return getHeaderLevel(this.content()?.subjectTaxonomyTags || []) ?? this.DEFAULT_HEADER_LEVEL;
  });

  headerFontLevel = computed((): string => {
    return getFontLevel(this.content()?.subjectTaxonomyTags || []) ?? 'font-headline-small';
  });
}
